import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import { getInitials } from "@/lib/utils";
import { warningAccentBackgroundStyle } from "@/components/ui/feedback/warningVisual";

export type AvatarProps = HTMLAttributes<HTMLDivElement> & {
  src?: string;
  alt?: string;
  name?: string;
  size?: "sm" | "md" | "lg";
  status?: "online" | "busy" | "offline";
};

const sizeMap = {
  sm: "bfrs-size-8 bfrs-text-xs",
  md: "bfrs-size-10 bfrs-text-sm",
  lg: "bfrs-size-12 bfrs-text-base"
};

const statusMap = {
  online: "bfrs-bg-success",
  busy: "",
  offline: "bfrs-bg-text-disabled"
};

export const Avatar = forwardRef<HTMLDivElement, AvatarProps>(({ className, src, alt, name, size = "md", status, ...props }, ref) => (
  <div ref={ref} className={cn("bfrs-relative bfrs-inline-flex bfrs-shrink-0", className)} {...props}>
    <div className={cn("bfrs-flex bfrs-items-center bfrs-justify-center bfrs-overflow-hidden bfrs-rounded-pill bfrs-bg-primary-soft bfrs-font-bold bfrs-text-primary", sizeMap[size])}>
      {src ? <img src={src} alt={alt ?? name ?? ""} className="bfrs-size-full bfrs-object-cover" /> : <span>{getInitials(name)}</span>}
    </div>
    {status && <span className={cn("bfrs-absolute bfrs-bottom-0 bfrs-right-0 bfrs-size-3 bfrs-rounded-pill bfrs-border-2 bfrs-border-surface-card", statusMap[status])} style={status === "busy" ? warningAccentBackgroundStyle : undefined} aria-label={status} />}
  </div>
));

Avatar.displayName = "Avatar";
